import { useEffect, useState } from 'react';
import { extractOptions } from 'src/util/helpers';
import useMediaOptions from './useMediaOptions';

const useWithOrder = ({
  exercise,
  setSelectedAnswer,
  selectedAnswer,
  hasAudio,
  disabled
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [mediaList, setMediaList] = useState(() => extractOptions(exercise?.options) || []);
  const { 
    currentlyPlaying,
    onAudioPlay,
    stopAllAudio
  } = useMediaOptions({
    exercise,
    hasAudio: true
  });

  useEffect(() => {
    setMediaList(extractOptions(exercise?.options) || []);
    setSelectedOptions([]);
  }, [exercise]);

  useEffect(() => {
    const answer = selectedOptions.map(opt => opt?.nativeValue?.trim() ?? '').join(' ').trim();
    setSelectedAnswer(answer);
  }, [selectedOptions, setSelectedAnswer]);

  const handleItemClick = (option, index) => {
    if (disabled || !option) return;

    stopAllAudio();
    onAudioPlay(option.nativeFile, `option-${option.key}`);

    setSelectedOptions(prev => [...prev, option]);
    setMediaList(prev => {
      const newList = [...prev];
      newList[index] = null;
      return newList;
    });
  };

  const handleSelectedItemClick = (option, selectedIndex) => {
    if (disabled || !option) return;

    stopAllAudio();
    onAudioPlay(option.nativeFile, `option-${option.key}`);

    setSelectedOptions(prev => prev.filter((_, i) => i !== selectedIndex));
    setMediaList(prev => {
      const newList = [...prev];
      const emptyIndex = newList.findIndex(item => item === null);
      if (emptyIndex >= 0) {
        newList[emptyIndex] = option;
      } else {
        // If no empty slot, add to end
        newList.push(option);
      }
      return newList;
    });
  };

  return {
    mediaList,
    selectedOptions,
    onItemClick: handleItemClick,
    onSelectedItemClick: handleSelectedItemClick,
    currentlyPlaying,
    onAudioPlay,
    stopAllAudio
  };
};

export default useWithOrder;